export default "__VITE_ASSET__DEjSzBJD__"